import {Modal} from 'antd';
import React from 'react';
import {Calendly} from './Calendly';


export const CalendlyModal = ({onSuccess, isMobile, open, onCancel, title}) => {
  return (
    <Modal
      title={title}
      open={open}
      footer={null}
      onCancel={onCancel}
      destroyOnClose={true}
      width={isMobile ? '100%' : 1000}
    >
      <Calendly onSuccess={onSuccess} />
    </Modal>
  )
}
